import { Badge as BadgeBase } from 'reactstrap'
import styled from 'styled-components'

export const Badge = styled(BadgeBase)`
    font-size: 18px;
`
